import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { build } from '../../../../../assets/build-number';
import { PlatformService } from 'app/core/services/platform.service';
import { PushService } from 'app/core/services/push.service';

@Component({
  standalone: false,
  selector: 'pptl-modal-help',
  templateUrl: './modal-help.component.html',
  styleUrls: ['./modal-help.component.scss'],
})
export class ModalHelpComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public modalController: ModalController,
    private platformService: PlatformService,
    private pushService: PushService,
  ) {}

  ngOnInit(): void {
    this.pushService.isModalClosed.pipe(
      takeUntil(this.destroy$),
    ).subscribe(() => {
      this.onCancelButtonClick();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  onCancelButtonClick(): void {
    this.modalController.dismiss();
  }

  get getAppVersion() {
    return build.version;
  }

  get isMobile(): boolean {
    return this.platformService.isMobile();
  }
}
